var locale = {
  locale: 'zh',
  today: '今日',
  yesterday: '昨天',
  lastThreeDay: '最近三天',
  lastWeek: '最近一周',
  lastMonth: '最近一个月',
  lastHalfYear: '最近六个月',
  all: '全部'
};
export default locale;